module.exports = __webpack_public_path__ + "fromBrideToMother-we-r.84c0f2cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/fromBrideToMother-we-r.jpg
// module id = iJTB
// module chunks = 0